export { default as MountStory } from './MountStory';
export { default as RenderStory } from './RenderStory';
export function generateSourceCode() {
    // noop
}
